import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AssetPayload = {
    provider: string;
    id: number;
};

export type DrmData = {
    state: 'transcode' | 'done' | 'error';
    progress: number;
    error?: string;
};

const initialState: Record<string, Record<'drm', DrmData>> = {};

function assetKey(provider: string, assetId: number) {
    return `${provider}:${assetId}`;
}

const drmSlice = createSlice({
    name: 'drm',
    initialState,
    reducers: {
        drmStart(state, action: PayloadAction<AssetPayload>) {
            const { provider, id } = action.payload;
            state[assetKey(provider, id)] = { drm: { state: 'transcode', progress: 5 } };
        },
        drmProgress(state, action: PayloadAction<AssetPayload & { progress: number }>) {
            const { provider, id, progress } = action.payload;
            const key = assetKey(provider, id);
            if (!state[key]) {
                state[key] = { drm: { state: 'transcode', progress } };
            } else {
                state[key].drm.state = 'transcode';
                state[key].drm.progress = progress;
            }
        },
        drmEnd(state, action: PayloadAction<AssetPayload>) {
            const { provider, id } = action.payload;
            const key = assetKey(provider, id);
            if (state[key]) {
                state[key].drm.state = 'done';
                state[key].drm.progress = 100;
            }
        },
        drmError(state, action: PayloadAction<AssetPayload & { error: string }>) {
            const { provider, id, error } = action.payload;
            state[assetKey(provider, id)] = { drm: { state: 'error', progress: 0, error } };
        },
    },
});

export const { drmStart, drmProgress, drmEnd, drmError } = drmSlice.actions;

export default drmSlice;
